import { render, staticRenderFns } from "./userSelect.vue?vue&type=template&id=afffab2c&"
import script from "./userSelect.vue?vue&type=script&lang=js&"
export * from "./userSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports